import { useState } from "react";
import { axiosPrivate } from "../../../api/axios";

//Styling
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

//Components
import LoadingSpinner from "../../loadingSpinner/LoadingSpinner";
import Error from "../Error";

//Translation
import { useTranslation } from 'react-i18next';



export default function PostDelete({ setPosts, postId, postSender, loggedInUser, isNavOpen, setError, setShowConfirmDelete }) {

  const { t } = useTranslation();

  const [postIdToDelete, setPostIdToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [nonCriticalError, setNonCriticalError] = useState('')

  const handlePostDelete = (postId) => {
    const deletePost = async () => {
      try {
        setIsLoading(true);

        await axiosPrivate.put(`/posts/delete/${postId}`, { loggedInUser });

        setPosts((prevPosts) =>
          prevPosts.filter((post) => post.id !== postId)
        );

        setPostIdToDelete(null);
        setShowConfirmDelete(false);
      } catch (err) {
        console.error('Post delete failed:', err);

        const status = err?.response?.status;
        const backendMessage =
          err?.response?.data?.error || t('postDelete.errorFailed');

        // 👉 NON-CRITICAL error (demo restriction)
        if (status === 403) {
          setNonCriticalError(backendMessage);
          return; // ⛔ do NOT trigger critical error UI
        }

        // 👉 CRITICAL error
        setError(backendMessage);
      } finally {
        setIsLoading(false);
      }
    };

    deletePost();
  };


  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>    {loggedInUser === postSender && (
      <div className="post-actions">
        {postIdToDelete === postId && (
          <div className="confirm-delete-chat">
            <p
              className="button-red"
              onClick={() => {
                handlePostDelete(postId);
              }}
            >
              {t('postDelete.confirmDelete')}
            </p>
            <p
              className="button-white"
              style={{ color: "black" }}
              onClick={() => {
                setPostIdToDelete(null)
                setShowConfirmDelete(false)
                setNonCriticalError('')
              }
              }
            >
              {t('postDelete.cancel')}
            </p>
          </div>
        )}

        {postIdToDelete !== postId && (
          <button
            onClick={() => {
              setPostIdToDelete(postId)
              setShowConfirmDelete(true)
            }
            } // Show confirmation modal for this post
            title={t('postDelete.title')}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
        )}

      </div>

    )}


      {nonCriticalError && (
        <div className="non-critical-error">
          {nonCriticalError}
        </div>
      )}

    </>

  )
}